import {Component, OnInit} from '@angular/core';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {AlertService} from 'src/app/services/alert/alert.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DocumentManagerService} from 'src/app/services/document-manager/document-manager.service';
import {formatDate} from '@angular/common';
import {GridOptions} from "ag-grid-community";

@Component({
    selector: 'app-frt-temp-non-use-tsps-doc-mgmt-rpt',
    templateUrl: './frt-temp-non-use-tsps-doc-mgmt-rpt.component.html',
    styleUrls: ['./frt-temp-non-use-tsps-doc-mgmt-rpt.component.css'],
    standalone: false
})
export class FRTTempNonUseDocMgmtReportComponent implements OnInit {
  gridOptions: GridOptions = this.initializeGridOptions();
  docMgmtRptColumnDefs = [
    
    {headerName: 'SCAC', field: 'scac', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'SCAC Name', field: 'scacName', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Reporting Official', field: 'nameOfResponsiblePerson', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Reporting Official Email', field: 'emailOfResponsiblePerson', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Certificate Of SCAC', field: 'certificateOfScac', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Certificate Of Liability Insurance', field: 'certificateOfLiabilityInsurance', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'TSP Agreement', field: 'tspAgreement', filter: 'agTextColumnFilter', sortable: true}
  ];
  excelStyles = [
    {
      id: 'textFormat',
      dataType: 'string',
    }
  ];
  documentManagementList: any = [{}];
  
  format = 'MM/dd/yyyy';
  locale = 'en-US';

  public errorMessage = '';
  order = 'faic';
  reverse = false;

  private strloader;
  paginationPageSize;
  domLayout;
  faicListDetails = [
    {}
  ];

  constructor(
    private alertService: AlertService,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private documentManagerService: DocumentManagerService,
    private router: Router) {
    this.paginationPageSize = 25;
  }

  /**
   * initializing the grid
   */
  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      defaultCsvExportParams: {
        fileName: 'FRT_Temp_Non_Use_Document_Management_Report'
      },
      defaultExcelExportParams: {
        fileName: 'FRT_Temp_Non_Use_Document_Management_Report'
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  ngOnInit() {    
    this.onSearch();
  }

  onSearch() {

    this.loadingService.show();
    // call to server for data.  Results will be stored in faicListDetails.
    this.documentManagerService.getFRTTempNonUseTSPsWithNoOrMissingDocs()
      .subscribe(data => {
          this.documentManagementList = data;
        },
        (error) => {
          this.errorMessage = error;
          console.log('No records found for the search criteria: ' + error);
          this.alertService.error('No records found for the search criteria ');
          this.loadingService.hide();
        }, () => {
          console.log('Successfully retrieved document report details: ', this.faicListDetails);
          this.loadingService.hide();
        }
      );
  }

  goBack() {
    this.router.navigate(['/documentmanagement'],
      {
        queryParams: {
          businessTypeBack: ['FRT']
        }
      });
  }

}
